import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [RouterLink],
  template: `
    <div class="not-found-container">
      <img
        src="https://cdn-icons-png.flaticon.com/512/7486/7486811.png"
        alt="Not Found"
        class="not-found-image"
      />

      <h1>Oops! Page Not Found</h1>
      <p>The page you're looking for doesn't exist or was moved.</p>

      <a routerLink="/" class="home-button">Go Back Home</a>
    </div>
  `,
  styles: [
    `
      .not-found-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 80vh;
        text-align: center;
        padding: 20px;
        animation: fadeIn 0.5s ease-in-out;
      }

      .not-found-image {
        width: 180px;
        height: auto;
        margin-bottom: 20px;
        opacity: 0.9;
      }

      h1 {
        font-size: 36px;
        margin: 10px 0;
        color: #00008f; /* AXA blue */
        font-weight: 700;
      }

      p {
        font-size: 18px;
        color: #555;
        margin-bottom: 30px;
      }

      .home-button {
        background-color: #00008f;
        color: white;
        padding: 12px 28px;
        text-decoration: none;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 600;
        transition: 0.25s ease;
      }

      .home-button:hover {
        background-color: #0010c4;
        transform: translateY(-2px);
      }

      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: translateY(10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `,
  ],
})
export class PageNotFoundComponent {}
